export const CLASS_NAME = 'cst-map'
